export default __webpack_public_path__ + "static/skills-tag-colored-dark-a8ac21910731b4b92fccd7f34b98cac2.png";